// extracted by mini-css-extract-plugin
export default {"image":"FullProduct_image__QBZ-E","cost":"FullProduct_cost__67Y2r","rating":"FullProduct_rating__APiGA","button":"FullProduct_button__+Dhjd"};